<template>
    <progress-bar :diameter="200" :completed-steps="completedSteps" :total-steps="totalSteps">
        <!-- <template v-slot:header>this is header slot </template> -->
        <!-- <template v-slot:footer> this is footer slot</template> -->
        <template v-slot:tip>
            <div class="text-center">
                {{(completedSteps/totalSteps)*100}}%
            </div>
        </template>
    </progress-bar>
</template>

<script>
import ProgressBar from "vue2-progress-bar";

export default {
    data() {
        return {

        };
    },
    components: {
        ProgressBar
    },
    props: {
        diameter: {
            type: Number,
            default: 200
        },
        completedSteps: {
            type: [Number, String],
            default: 0
        },
        totalSteps: {
            type: Number,
            default: 100
        }
    }
};
</script>
<style>
.progress-bar {

    background-color: transparent;

}
</style>
